import { render, staticRenderFns } from "./userFace.vue?vue&type=template&id=19bb5254&scoped=true&"
import script from "./userFace.vue?vue&type=script&lang=js&"
export * from "./userFace.vue?vue&type=script&lang=js&"
import style0 from "./userFace.vue?vue&type=style&index=0&id=19bb5254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb5254",
  null
  
)

export default component.exports